import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArtistPresenter from './ArtistPresenter';
import { useScrollTop } from '../../hooks';
import { artist as artistApi } from '../../api';

import ajm from '../../images/ajm/profile/1.jpeg';
import ghe from '../../images/ghe/profile/1.jpg';
import jhs from '../../images/jhs/profile/1.jpg';
import jj from '../../images/jj/profile/1.jpg';
import jjh from '../../images/jjh/profile/1.jpg';
import jns from '../../images/jns/profile/1.jpg';
import kbb from '../../images/kbb/profile/1.jpeg';
// import lhe from '../../images/lhe/profile/1.jpg';
// import lsb from '../../images/lsb/profile/1.jpg';
import lsk from '../../images/lsk/profile/1.png';
// import bej from '../../images/bej/profile/1.jpg';

import ajmCircle from '../../images/ajm/circle_profile/img-circle-02@3x.png';
import gheCircle from '../../images/ghe/circle_profile/img-circle-08@3x.png';
import jhsCircle from '../../images/jhs/circle_profile/img-circle-01@3x.png';
import jjCircle from '../../images/jj/circle_profile/img-circle-10@3x.png';
import jjhCircle from '../../images/jjh/circle_profile/img-circle-09@3x.png';
import jnsCircle from '../../images/jns/circle_profile/img-circle-07@3x.png';
import kbbCircle from '../../images/kbb/circle_profile/img-circle-05@3x.png';
// import lheCircle from '../../images/lhe/circle_profile/img-circle-03@3x.png';
// import lsbCircle from '../../images/lsb/circle_profile/img-circle-06@3x.png';
import lskCircle from '../../images/lsk/circle_profile/img-circle-04@3x.png';
// import bejCircle from '../../images/bej/circle_profile/img-circle-10@3x.png';

const artistInitState = [
  { id: 'jhs', name: '정혜선', img: jhs, circle: jhsCircle },
  { id: 'ajm', name: '안재모', img: ajm, circle: ajmCircle },
  // { id: 'lhe', name: '이황의', img: lhe, circle: lheCircle },
  { id: 'lsk', name: '이수경', img: lsk, circle: lskCircle },
  { id: 'kbb', name: '김비비', img: kbb, circle: kbbCircle },
  // { id: 'lsb', name: '이상보', img: lsb, circle: lsbCircle },
  { id: 'jns', name: '장남수', img: jns, circle: jnsCircle },
  { id: 'ghe', name: '길하은', img: ghe, circle: gheCircle },
  // { id: 'bej', name: '배은지', img: bej, circle: bejCircle },
  { id: 'jjh', name: '장정한', img: jjh, circle: jjhCircle },
  { id: 'jj', name: '준재', img: jj, circle: jjCircle },
];

const ArtistContainer = () => {
  const [artist, setArtist] = React.useState(artistInitState);
  const navigate = useNavigate();

  const navigateToProfile = (id) => {
    navigate(`/artist/${id}`);
  }

  const getArtist = async () => {
    try {
      const response = await artistApi.getArtist();
      console.log('[getArtist] response.data : ', response.data);
      // setArtist(response.data.artist);
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    // getArtist();
  }, []);
  
  useScrollTop();

  return <ArtistPresenter artist={artist} navigateToProfile={navigateToProfile} />;
};

export default ArtistContainer;
